import { fetchWithAuth } from "../../../api/http";
import type { ScenariosBlock, ScenarioBand } from "../domain/scenarios";

/** POST /{projects,loads}/{id}/sensitivity/sweep response. */
export interface SweepEnqueueResponse {
  asset_id: string;
  asset_kind: "project" | "load";
  enqueued: number;
  scenario_keys: string[];
  model_version?: string | null;
  config_hash?: string | null;
  task_ids: string[];
  estimated_minutes?: number | null;
}

export interface StoredScenarioResult {
  scenario_key: string;
  model_version?: string | null;
  config_hash?: string | null;
  computed_at?: string | null;
  band?: ScenarioBand | null;
}

/** GET /{projects,loads}/{id}/sensitivity response. */
export interface AssetSensitivityResponse {
  asset_id: string;
  asset_kind: "project" | "load";
  sweep_status: ScenariosBlock["status"];
  model_version?: string | null;
  config_hash?: string | null;
  scenarios: ScenariosBlock;
  results: StoredScenarioResult[];
}

// --- Projects ---

export const triggerProjectSweep = (projectId: string, token: string) =>
  fetchWithAuth<SweepEnqueueResponse>(
    `/projects/${projectId}/sensitivity/sweep`,
    token,
    { method: "POST", body: JSON.stringify({}) },
  );

export const getProjectSensitivity = (projectId: string, token: string) =>
  fetchWithAuth<AssetSensitivityResponse>(
    `/projects/${projectId}/sensitivity`,
    token,
  );

// --- Loads ---

export const triggerLoadSweep = (loadId: string, token: string) =>
  fetchWithAuth<SweepEnqueueResponse>(
    `/loads/${loadId}/sensitivity/sweep`,
    token,
    { method: "POST", body: JSON.stringify({}) },
  );

export const getLoadSensitivity = (loadId: string, token: string) =>
  fetchWithAuth<AssetSensitivityResponse>(`/loads/${loadId}/sensitivity`, token);
